import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    Input,
    OnChanges,
    OnDestroy,
    QueryList,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessorBase } from '@fi-shared/control-value-accessor-validator-base';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FiOptionsItemBase } from '@fi-shared/fi-options/fi-options-item-base';

@Component({
    selector: 'fi-options',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./fi-options.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiOptionsComponent,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-options' },
    standalone: false,
})
export class FiOptionsComponent
    extends ControlValueAccessorBase<number>
    implements AfterViewInit, OnDestroy, OnChanges
{
    @Input() allowUncheck = false;

    @ContentChildren(FiOptionsItemBase) items: QueryList<FiOptionsItemBase>;

    private destroyed$ = new Subject<void>();

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.ngModel;
        if (change && !change.isFirstChange()) {
            this.updateSelectedOnOptionsItems();
        }
    }

    ngAfterViewInit(): void {
        this.getOptionItems().forEach((item) => {
            item.onSelect$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
                this.ngModel = this.allowUncheck && this.ngModel === item.value ? null : item.value;
                this.doPropagateChanges();
                this.updateSelectedOnOptionsItems();
            });
        });
        this.updateSelectedOnOptionsItems();
    }

    private updateSelectedOnOptionsItems() {
        // we need setTimeout to prevent
        // Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'selected: false'. Current value: 'selected: true'.
        setTimeout(() =>
            this.getOptionItems().forEach((item) => {
                item.selected$.next(item.value === this.ngModel);
            }),
        );
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    private getOptionItems() {
        return this.items.toArray();
    }
}
